import { useTranslation } from 'react-i18next';
// import { ASSETS_BASE_URL } from '@/config';
import { Button, Icon, Typography } from '@/components';

export type OtherInformationBoxProps = {
  readonly normalizedProject: any;
  readonly technology: any;
  readonly onEdit?: () => void;
  readonly isEditable: boolean;
};

export function OtherInformationBox({ normalizedProject, technology, isEditable, onEdit }: OtherInformationBoxProps) {
  const { t } = useTranslation(['projects']);
  const other_info = normalizedProject.otherInfo?.[0];

  // const files = technology[0]?.details?.files ?? [];

  if (!isEditable && other_info === undefined) return null;

  const typeOfRevenue = [
    { label: 'Merchant', value: 'merchant' },
    { label: 'Contracted', value: 'contracted' },
  ];

  const allFields = [
    { label: t('Type of Revenue'), value: typeOfRevenue.find((info) => info.value === other_info?.type_of_revenue)?.label},
    { label: t('Energy offset'), value: other_info?.energy_offset },
    {
      label: t('Energy offset Details'),
      value: (
        <span className="text-base font-normal whitespace-pre-wrap text-neutral-900">
          {other_info?.energy_offset_details}
        </span>
      ),
    },
    {
      label: t('Financial details'),
      value: (
        <span className="text-base font-normal whitespace-pre-wrap text-neutral-900">
          {other_info?.financial_details}
        </span>
      ),
    },
    {
      label: t('Other Comments'),
      value: (
        <span className="text-base font-normal whitespace-pre-wrap text-neutral-900">{other_info?.other_comments}</span>
      ),
    },
    // {
    //   label: t('Files'),
    //   value:
    //     files.length > 0 ? (
    //       <>
    //         {files.map((file: any, index: number) => (
    //           <span key={file.id}>
    //             <a
    //               href={`${ASSETS_BASE_URL}/${file.id}`}
    //               target="_blank"
    //               rel="noreferrer"
    //               className="text-primary-700 hover:underline"
    //             >
    //               {file.title || file.filename_download || 'Untitled'}
    //             </a>
    //             {index < files.length - 1 && ', '}
    //           </span>
    //         ))}
    //       </>
    //     ) : (
    //       '—'
    //     ),
    // },
  ];

  const visibleFields = isEditable
    ? allFields
    : allFields.filter(({ value }) => value !== null && value !== undefined && value !== '');

  return (
    <div className="rounded-lg border border-neutral-50 bg-white p-6 shadow-xs">
      <div className="mb-6 flex items-center">
        <div className="flex grow items-center">
          <div className="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-50">
            <Icon name="info" className="h-6 w-6" />
          </div>
          <Typography as="h3" weight="semibold" size="title">
            {t('Other Information')}
          </Typography>
        </div>
        {isEditable && (
          <Button size="sm" color="neutral" icon="edit" onClick={onEdit} className="ml-auto">
            {t('Edit')}
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1">
        {visibleFields.map(({ label, value }) => (
          <Typography key={label} as="p" size="body-2" weight="semibold" relaxed className="mb-1">
            {label}:{' '}
            <span className="ml-3 text-base font-normal text-neutral-900">{value ?? (isEditable ? '—' : null)}</span>
          </Typography>
        ))}
      </div>
    </div>
  );
}
